const initialState = {
  d2dEidQuestionAns: null,
};

function d2dEidQA(state = initialState, action) {
  switch (action.type) {
    case 'D2D_EID_QUESTION_ANS':
      return { ...state, d2dEidQuestionAns: action.response && action.response };
    case 'D2D_EID_ANSWERS':
      return { ...state, d2dEidAnswers: action.response && action.response };
    default:
      return state;
  }
}


export default d2dEidQA;
